$(".facets-toggler").click(function () {
  $(".facets ").slideToggle();
  $(this).toggleClass("open");
});

const target = document.querySelector(".facets-container");
const stickyClass = "make-it-sticky";

// container ki original position calculate kar lo
const containerOffsetTop = target.offsetTop; // distance from top of page

function checkSticky() {
  const scrollTrigger = containerOffsetTop + -100;
  if (window.scrollY >= scrollTrigger) {
    target.classList.add(stickyClass);
  } else {
    target.classList.remove(stickyClass);
  }
}

// scroll aur load pe call karo
window.addEventListener("scroll", checkSticky);
window.addEventListener("load", checkSticky);

// toggle description

document.addEventListener("click", function (e) {
  if (!e.target.matches("#desc-toggle-btn")) return;

  const desc = document.querySelector(".collecton-desc");
  if (!desc) return;

  desc.classList.toggle("expanded");

  e.target.textContent = desc.classList.contains("expanded")
    ? "Weniger anzeigen"
    : "Mehr anzeigen";
});